import { createContext } from "react";

export const DocumentAccess = createContext({
  roomId: "",
  userId: "",
  sessionId: null as string | null,
  connected: false,
  canEdit: false,
});
